import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';

import CreditCardStore from 'js/stores/pages/AdminDashboardPage/CreditCardStore';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';

import List from '../../List';
import Row from '../../List/Row';
import ListItem from '../../List/ListItem';
import ListMessage from '../../List/ListMessage';

import User from '../../Display/User';
import Transaction from './Transaction';

@observer
export default class CreditCard extends Component {
  credit_card = CreditCardStore.create({ id: parseInt(this.props['*']) });

  constructor(props) {
    super(props);
    this.credit_card.load();
  }

  render() {
    const credit_card = this.credit_card;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/credit_cards">Credit cards</Link>
            {credit_card.credit_card && (
              <>
                <Icon name="chevron-right" />
                <Text>{credit_card.credit_card}</Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={credit_card}>
          <Content background={adminPanelColor}>
            {credit_card.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image src={`/images/payment-icons/${credit_card.credit_card_type}.png`} />
                  </Display>

                  <Details>
                    <Label>Created</Label>
                    <div>{credit_card.created_at}</div>

                    <Label>Credit card</Label>
                    <div>{credit_card.credit_card}</div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <User load={{ credit_card_id: credit_card.id }} title="Owner" />
                  </Row>

                  <Row>
                    <List paginator={credit_card.transactions} title="Transactions" icon="list" controls="more">
                      <div>
                        {credit_card.transactions.transactions.length ? (
                          credit_card.transactions.transactions.map(transaction => (
                            <ListItem key={transaction.id} to={`/admin/transactions/transaction/${transaction.id}`}>
                              <Transaction transaction={transaction} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>No transactions found</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>
                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
